import { Box, CircularProgress } from '@mui/material';
import React from 'react';

/** The spinner every preview shows while it is being prepared. */
export default function PreviewLoading() {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
      <CircularProgress aria-label="Loading preview" />
    </Box>
  );
}
